module.exports = __webpack_public_path__ + "img/ds3.f0acf3d1.png";